package com.github.jangalinski.tabweb._foundation.modifier

import com.github.jangalinski.tabweb._foundation.Initials
import com.github.jangalinski.tabweb._foundation.Tabweb
import com.github.jangalinski.tabweb._foundation.css.CssClass
import com.github.jangalinski.tabweb._foundation.css.cssClass
import com.github.jangalinski.tabweb.icon.Icon
import com.github.jangalinski.tabweb.icon.TabwebIcon
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.classNames
import kotlin.String

public sealed interface BackgroundColor : Tabweb.Color {
  public val textFg: CssClass

  public enum class BASE(
    override val `value`: String,
    override val initials: Initials,
    override val displayName: String,
    override val textFg: CssClass,
  ) : BackgroundColor,
      Modifier {
    AZURE("bg-azure", Initials("az"), "Azure", cssClass("text-azure-fg")),
    BLUE("bg-blue", Initials("bl"), "Blue", cssClass("text-blue-fg")),
    CYAN("bg-cyan", Initials("cy"), "Cyan", cssClass("text-cyan-fg")),
    GREEN("bg-green", Initials("gn"), "Green", cssClass("text-green-fg")),
    INDIGO("bg-indigo", Initials("id"), "Indigo", cssClass("text-indigo-fg")),
    LIME("bg-lime", Initials("lm"), "Lime", cssClass("text-lime-fg")),
    ORANGE("bg-orange", Initials("or"), "Orange", cssClass("text-orange-fg")),
    PINK("bg-pink", Initials("pk"), "Pink", cssClass("text-pink-fg")),
    PURPLE("bg-purple", Initials("pu"), "Purple", cssClass("text-purple-fg")),
    RED("bg-red", Initials("rd"), "Red", cssClass("text-red-fg")),
    TEAL("bg-teal", Initials("tl"), "Teal", cssClass("text-teal-fg")),
    YELLOW("bg-yellow", Initials("yl"), "Yellow", cssClass("text-yellow-fg")),
    WHITE("bg-white", Initials("wt"), "White", cssClass("text-white-fg")),
    BLACK("bg-black", Initials("bk"), "Black", cssClass("text-black-fg")),
    ;

    private val modifier: Modifier by lazy {
      Modifier.classNames(value)
    }

    override fun <R> fold(initial: R, operation: (R, Modifier.Element) -> R): R = modifier.fold(initial, operation)

    override fun then(other: Modifier): Modifier = modifier.then(other)
  }

  public enum class LIGHT(
    override val `value`: String,
    override val initials: Initials,
    override val displayName: String,
    override val textFg: CssClass,
  ) : BackgroundColor,
      Modifier {
    AZURE("bg-azure-lt", Initials("azl"), "Azure Light", cssClass("text-azure-fg")),
    BLUE("bg-blue-lt", Initials("bll"), "Blue Light", cssClass("text-blue-fg")),
    CYAN("bg-cyan-lt", Initials("cyl"), "Cyan Light", cssClass("text-cyan-fg")),
    GREEN("bg-green-lt", Initials("gnl"), "Green Light", cssClass("text-green-fg")),
    INDIGO("bg-indigo-lt", Initials("idl"), "Indigo Light", cssClass("text-indigo-fg")),
    LIME("bg-lime-lt", Initials("lml"), "Lime Light", cssClass("text-lime-fg")),
    ORANGE("bg-orange-lt", Initials("orl"), "Orange Light", cssClass("text-orange-fg")),
    PINK("bg-pink-lt", Initials("pkl"), "Pink Light", cssClass("text-pink-fg")),
    PURPLE("bg-purple-lt", Initials("pul"), "Purple Light", cssClass("text-purple-fg")),
    RED("bg-red-lt", Initials("rdl"), "Red Light", cssClass("text-red-fg")),
    TEAL("bg-teal-lt", Initials("tll"), "Teal Light", cssClass("text-teal-fg")),
    YELLOW("bg-yellow-lt", Initials("yll"), "Yellow Light", cssClass("text-yellow-fg")),
    WHITE("bg-white-lt", Initials("wtl"), "White Light", cssClass("text-white-fg")),
    ;

    private val modifier: Modifier by lazy {
      Modifier.classNames(value)
    }

    override fun <R> fold(initial: R, operation: (R, Modifier.Element) -> R): R = modifier.fold(initial, operation)

    override fun then(other: Modifier): Modifier = modifier.then(other)
  }

  public enum class GRAY(
    override val `value`: String,
    override val initials: Initials,
    override val displayName: String,
    override val textFg: CssClass,
  ) : BackgroundColor,
      Modifier {
    GRAY_50("bg-gray-50", Initials("50"), "Gray 50", cssClass("text-gray-50-fg")),
    GRAY_100("bg-gray-100", Initials("100"), "Gray 100", cssClass("text-gray-100-fg")),
    GRAY_200("bg-gray-200", Initials("200"), "Gray 200", cssClass("text-gray-200-fg")),
    GRAY_300("bg-gray-300", Initials("300"), "Gray 300", cssClass("text-gray-300-fg")),
    GRAY_400("bg-gray-400", Initials("400"), "Gray 400", cssClass("text-gray-400-fg")),
    GRAY_500("bg-gray-500", Initials("500"), "Gray 500", cssClass("text-gray-500-fg")),
    GRAY_600("bg-gray-600", Initials("600"), "Gray 600", cssClass("text-gray-600-fg")),
    GRAY_700("bg-gray-700", Initials("700"), "Gray 700", cssClass("text-gray-700-fg")),
    GRAY_800("bg-gray-800", Initials("800"), "Gray 800", cssClass("text-gray-800-fg")),
    GRAY_900("bg-gray-900", Initials("900"), "Gray 900", cssClass("text-gray-900-fg")),
    GRAY_950("bg-gray-950", Initials("950"), "Gray 950", cssClass("text-gray-950-fg")),
    ;

    private val modifier: Modifier by lazy {
      Modifier.classNames(value)
    }

    override fun <R> fold(initial: R, operation: (R, Modifier.Element) -> R): R = modifier.fold(initial, operation)

    override fun then(other: Modifier): Modifier = modifier.then(other)
  }

  public enum class SOCIAL(
    override val `value`: String,
    override val initials: Initials,
    override val displayName: String,
    public val icon: Icon,
    override val textFg: CssClass,
  ) : BackgroundColor,
      Modifier {
    FACEBOOK("bg-facebook", Initials("fb"), "Facebook", TabwebIcon.TI_BRAND_FACEBOOK, cssClass("text-facebook-fg")),
    TWITTER("bg-twitter", Initials("tw"), "Twitter", TabwebIcon.TI_BRAND_TWITTER, cssClass("text-twitter-fg")),
    INSTAGRAM("bg-instagram", Initials("ig"), "Instagram", TabwebIcon.TI_BRAND_INSTAGRAM, cssClass("text-instagram-fg")),
    LINKEDIN("bg-linkedin", Initials("li"), "LinkedIn", TabwebIcon.TI_BRAND_LINKEDIN, cssClass("text-linkedin-fg")),
    X("bg-x", Initials("x"), "X", TabwebIcon.TI_BRAND_X, cssClass("text-x-fg")),
    GOOGLE("bg-google", Initials("gg"), "Google", TabwebIcon.TI_BRAND_GOOGLE, cssClass("text-google-fg")),
    YOUTUBE("bg-youtube", Initials("yt"), "Youtube", TabwebIcon.TI_BRAND_YOUTUBE, cssClass("text-youtube-fg")),
    VIMEO("bg-vimeo", Initials("vm"), "Vimeo", TabwebIcon.TI_BRAND_VIMEO, cssClass("text-vimeo-fg")),
    DRIBBBLE("bg-dribbble", Initials("db"), "Dribbble", TabwebIcon.TI_BRAND_DRIBBBLE, cssClass("text-dribbble-fg")),
    GITHUB("bg-github", Initials("gh"), "Github", TabwebIcon.TI_BRAND_GITHUB, cssClass("text-github-fg")),
    PINTEREST("bg-pinterest", Initials("pt"), "Pinterest", TabwebIcon.TI_BRAND_PINTEREST, cssClass("text-pinterest-fg")),
    VK("bg-vk", Initials("vk"), "VK", TabwebIcon.TI_BRAND_VK, cssClass("text-vk-fg")),
    RSS("bg-rss", Initials("rss"), "RSS", TabwebIcon.TI_RSS, cssClass("text-rss-fg")),
    FLICKR("bg-flickr", Initials("flr"), "Flickr", TabwebIcon.TI_BRAND_FLICKR, cssClass("text-flickr-fg")),
    BITBUCKET("bg-bitbucket", Initials("bb"), "Bitbucket", TabwebIcon.TI_BRAND_BITBUCKET, cssClass("text-bitbucket-fg")),
    TABLER("bg-tabler", Initials("tb"), "Tabler", TabwebIcon.TI_BRAND_TABLER, cssClass("text-tabler-fg")),
    ;

    private val modifier: Modifier by lazy {
      Modifier.classNames(value)
    }

    override fun <R> fold(initial: R, operation: (R, Modifier.Element) -> R): R = modifier.fold(initial, operation)

    override fun then(other: Modifier): Modifier = modifier.then(other)
  }

  public enum class SEMANTIC(
    override val `value`: String,
    override val initials: Initials,
    override val displayName: String,
    override val textFg: CssClass,
  ) : BackgroundColor,
      Modifier {
    DANGER("bg-danger", Initials("da"), "Danger", cssClass("text-danger-fg")),
    INFO("bg-info", Initials("in"), "Info", cssClass("text-info-fg")),
    PRIMARY("bg-primary", Initials("pr"), "Primary", cssClass("text-primary-fg")),
    SECONDARY("bg-secondary", Initials("se"), "Secondary", cssClass("text-secondary-fg")),
    SUCCESS("bg-success", Initials("su"), "Success", cssClass("text-success-fg")),
    TRANSPARENT("bg-transparent", Initials("tr"), "Transparent", cssClass("text-transparent-fg")),
    WARNING("bg-warning", Initials("wa"), "Warning", cssClass("text-warning-fg")),
    LIGHT("bg-light", Initials("li"), "Light", cssClass("text-light-fg")),
    DARK("bg-dark", Initials("da"), "Dark", cssClass("text-dark-fg")),
    ;

    private val modifier: Modifier by lazy {
      Modifier.classNames(value)
    }

    override fun <R> fold(initial: R, operation: (R, Modifier.Element) -> R): R = modifier.fold(initial, operation)

    override fun then(other: Modifier): Modifier = modifier.then(other)
  }

  public companion object {
    public val DEFAULT: BackgroundColor = SEMANTIC.TRANSPARENT
  }
}
